'use strict';module['exports']=function isCancel(_0x5498d1){return!!(_0x5498d1&&_0x5498d1['__CANCEL__']);};